module.exports = __webpack_public_path__ + "img/bn.59c57a1.svg";